<template>
  <div>
    <!-- Internet Connection Status -->
    <div class="internet-connection-status" id="internetStatus" :class="connectionStatus">
      <h4 class="mb-0">{{ connectionStatusText }}</h4>
    </div>
    <footer class="site-footer">
      <div class="container">
        <div class="row flex-row-reverse">
          <div class="col-md-8 text-right mt-5 footer-text-back">
          <div class="row">
            <div class="col-md-2 d-none">
              <h2 class="footer-heading mb-4">{{ $t('footer.services_title') }}</h2>
              <ul class="list-unstyled p-0">
                <li><NuxtLink :to="localePath('/')">{{ $t('footer.market_wholesale') }}</NuxtLink></li>
                <li><NuxtLink :to="localePath('/')">{{ $t('footer.market_retail') }}</NuxtLink></li>
                <li><NuxtLink :to="localePath('/')">{{ $t('footer.roostaban') }}</NuxtLink></li>
                <li><NuxtLink :to="localePath('/region/bar/tehran')">{{ $t('footer.price_ban') }}</NuxtLink></li>
              </ul>
            </div>
            <div class="col-md-2 d-none">
              <h2 class="footer-heading mb-4 ">{{ $t('footer.useful_links') }}</h2>
              <ul class="list-unstyled">
                <li><NuxtLink to="https://sarvban.com/">{{ $t('footer.home') }}</NuxtLink></li>
                <li><NuxtLink :to="localePath('/blog/')">{{ $t('footer.news_system') }}</NuxtLink></li>
                <li><NuxtLink :to="localePath('/about-sarvban/')">{{ $t('footer.about') }}</NuxtLink></li>
                <li><NuxtLink :to="localePath('/contact/')">{{ $t('footer.contact_title') }}</NuxtLink></li>
              </ul>
            </div>
            <div class="col-md-6">
              <h2 class="footer-heading mb-4">{{ $t('footer.site_title') }}</h2>
              <p class="text-justify">
              {{ $t('footer.description') }}
              <br>
              {{ $t('footer.tagline') }}
              </p>
            </div>
            <div class="col-md-4">
              <h2 class="footer-heading mb-4">{{ $t('footer.certs_title') }}</h2>
                <div class="certificates-container">
                  <section class="certs-container">
                  <div class="inner-wrapper">
                    <div class="cert-images-container"><span class="cert-image sarvban-footer-certificates" style="background: url('/market/img/danesh-bonyan.png');"><span class="link"><NuxtLink target="_blank" to="https://creativehousenet.ir/web/creative"></NuxtLink></span></span></div>
                    <div class="cert-images-container"><span class="cert-image sarvban-footer-certificates" style="background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+');"><span class="link"><NuxtLink target="_blank" href="//ecunion.ir/verify/sarvban.com?token=5293549609b9e4d168f5"></NuxtLink></span></span>
                    </div>
                    <div class="cert-images-container"><span class="cert-image sarvban-footer-certificates" style="background: url('/market/img/star1.png');"><span class="link"><NuxtLink referrerpolicy="origin" target="_blank" to="https://trustseal.enamad.ir/?id=156458&amp;Code=UHh1Z9hVzXIWQq9EHeQg"></NuxtLink></span></span>
                    </div>
                    <div class="cert-images-container" style="background: #868d56;"><span class="cert-image sarvban-footer-certificates" style="background: url('/market/img/Vastra_logonew_final-01.png');"><span class="link"><NuxtLink to="https://vastraholding.com/" referrerpolicy="origin" target="_blank"></NuxtLink></span></span></div>
                    <div class="cert-images-container"><span class="cert-image sarvban-footer-certificates" style="background: url('/market/img/samandehi.png');"><span class="link"><span onclick="window.open('https://logo.samandehi.ir/Verify.aspx?;, &quot;Popup&quot;,&quot;toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30')"></span></span></span>
                    </div>
                </div>

                </section>
              </div>
            </div>
          </div>
          <div class="row pt-2 mt-1 text-center">
            <div class="col-md-12">
              <div class="border-top pt-3">
                <p>
                <NuxtLink to="https://www.facebook.com/saarvban" class="px-3"><i class="fa-brands fa-facebook-f"></i></NuxtLink>
                <NuxtLink to="https://twitter.com/sarvban" class="px-3"><i class="fa-brands fa-twitter"></i></NuxtLink>
                <NuxtLink to="https://www.instagram.com/saarvban/" class="px-3"><i class="fa-brands fa-instagram"></i></NuxtLink>
                <NuxtLink to="https://www.linkedin.com/company/sarvban" class="px-3"><i class="fa-brands fa-linkedin-in"></i></NuxtLink>
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer Nav -->
    <div class="footer-nav-area" id="footerNav">
      <div class="sarv-footer-nav">
        <ul class="h-100 d-flex align-items-center justify-content-between ps-0 d-flex rtl-flex-d-row-r">
          <li>
            <NuxtLink :to="localePath('/')">
              <i class="fa-solid fa-house"></i>
              {{ $t('footer.nav_market') }}
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="localePath('/my-sarvban/messages')">
              <i class="fa-solid fa-comment-dots"></i>
              {{ $t('footer.nav_support') }}
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="localePath('/kind/seller/3358/محصولات%20صادراتی')">
              <i class="fa-solid fa-bag-shopping"></i>
              {{ $t('footer.nav_export') }}
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="localePath('/my-adv')">
              <i class="fa-solid fa-gear"></i>
              {{ $t('footer.nav_my_sarvban') }}
            </NuxtLink>
          </li>
          <li>
            <NuxtLink :to="localePath('/contact/')">
              <i class="fa-solid fa-heart"></i>
              {{ $t('footer.nav_contact') }}
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocalePath } from '#imports'
const { t } = useI18n()
const localePath = useLocalePath()

// Connection status
const connectionStatus = ref('online')
const connectionStatusText = ref(t('footer.online'))

// Methods
const checkConnectionStatus = () => {
  if (navigator.onLine) {
    connectionStatus.value = 'online'
    connectionStatusText.value = t('footer.online')
  } else {
    connectionStatus.value = 'offline'
    connectionStatusText.value = t('footer.offline')
  }
}

// Lifecycle hooks
onMounted(() => {
  checkConnectionStatus()
  
  // Set up event listeners
  window.addEventListener('online', checkConnectionStatus)
  window.addEventListener('offline', checkConnectionStatus)
})

onUnmounted(() => {
  // Clean up event listeners
  window.removeEventListener('online', checkConnectionStatus)
  window.removeEventListener('offline', checkConnectionStatus)
})
</script>

<style lang="scss" scoped>
@use "sass:color";

.certs-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 24px 0;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  .inner-wrapper {
        width: 328px;
        gap: 4px;
        margin: auto;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
  }
}
.cert-images-container {
    width: 56px;
    gap: 8px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border-radius: 4px;
    border: 1px solid var(--gray-DD, #ddd);

    a,span {
     display: block;
     width: 100%;
     height: 100%;
     cursor: pointer;
    }
    .cert-image {
      width: 56px;
      height: 56px;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: 50% !important;
    }
}
.sarvban-footer-certificates {
  
}

.site-footer {
  font-family: IRANYekanXFaNum;
  padding: 2em 0px 1rem 0px;
  background-image: url('/market/img/bottom_bar.jpeg');
  background-size: cover;
  height: 560px;
  background-position-y: -110px;
  background-position-x: right;
}

.footer-agree {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}

.footer-agree li {
  -webkit-flex-direction: row;
  flex-direction: row;
}

.site-footer .border-top {
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.site-footer p {
  color: #737373;
}

.site-footer h2,
.site-footer h3,
.site-footer h4,
.site-footer h5 {
  color: #fff;
}

.site-footer a {
  color: #313f1e;
}

.site-footer a:hover {
  color: white;
}

.site-footer ul li {
  margin-bottom: 10px;
}

.site-footer .footer-heading {
  font-size: 16px;
  color: $secondary;
  font-weight: bold;
}
.internet-connection-status {
  position: fixed;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  
  &.online {
    background-color: #28a745;
    display: none !important;
  }
  
  &.offline {
    background-color: #dc3545;
    display: flex !important;
    animation: slideDown 0.5s ease;
  }
}

.footer-nav-area {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #1e1e1e;
  height: 80px;
  
  .sarv-footer-nav {
    padding: 0px 20% 0px 20%;
    ul {
      li {
        flex: 1;
        text-align: center;
        padding: 10px 0;
        
        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #6c757d;
          transition: all 0.3s;
          font-size: 12px;
          
          i {
            font-size: 18px;
            margin-bottom: 5px;
          }
          
          &:hover {
            color: #03a054;
          }
        }
      }
    }
    @media (max-width: 576px) {
      padding: 0px;
      background:#fff;
      height: 100px;
      
    }
    @media (min-width: 576px) {
      display: none;
    }
  }
}
.footer-text-back{
  
  background: rgba(255, 255, 255, 0.4);
  padding: 20px;
  margin: 0px 0px;
  border-radius: 0.56rem;
}
@media (max-width: 768px) {
  .footer-text-back{
  
  background: rgba(255, 255, 255, 0.7);
  }
}

// Animation for connection status notification
@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>